module.exports = __webpack_public_path__ + "img/faceSuccessful.187f7831.png";